import React, { useState, useContext } from 'react'
import { armarPoliticas, capitalizeFirstLetter, convertirFecha } from '../../tools/utils';
import { Link } from 'react-router-dom'
import CardReserva from '../../CardReserva'
import CardBox from '../../CardBox';
import axios from 'axios';
import { ProductContext } from '../../../context/ProductContext';
import { LoaderIcon } from 'react-hot-toast';
import { formatearTexto } from '../../tools/utils';

const EventoFila = props => {

  const { miEvento, imagen, onEventoClick } = props;
  const [loading, setLoading] = useState(false)
  const [eventoFechas, setEventosFechas] = useState(null);
  const { setEvento } = useContext(ProductContext);
  const [verMas, setVerMas] = useState(false);

  // const showPrecioForDay = (fecha) => {
  //     //si es domingo
  //     const dia = new Date(fecha).getDay();
  //     if (dia === 6) {
  //       return '$ 3450';
  //     }
  //     return '$2900';
  // }

  // const showDiscountForDay = (fecha) => {
  //     //si es domingo
  //     const dia = new Date(fecha).getDay();
  //     if (dia === 6) {
  //       return '25%';
  //     }
  //     return '20%';
  // }

  // const armarPoliticas = (politicasDePrecio) => {
  //   return politicasDePrecio.map(pol => {
  //     return <span key={pol.id} className="price trajan-pro">{pol.descripcion} <br /></span>;
  //   })
  // }


  const cargarFechas = async (evento) => {
    //console.log(evento)

    setLoading(true)

    try {
      const data = {
        peticion: 26,
        idProducto: evento.idProducto
      }
      const response = await axios.post('https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosEventos.php', data)
      //console.log(response.data)
      if (response.data) {
        setEventosFechas(response.data)
        setVerMas(true)
      }
    }
    catch (error) {
      console.error(error)

    }
    finally {
      setLoading(false)
    }


  }


  return (

    <div className='p-0 md:pl-10 md:pr-20 md:pt-10 md:pb-5'>
      <CardBox>
        <CardReserva img={imagen} title={miEvento.denominacion}>
          {miEvento.observaciones ? (formatearTexto(miEvento.observaciones)) : ''}

          <br />
          <Link onClick={() => cargarFechas(miEvento)} role="button" >
            <span className="mt-5 inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded bg-emerald-500 px-6 text-md font-medium tracking-wide text-white transition duration-300 hover:bg-emerald-600 focus:bg-emerald-700 focus-visible:outline-none disabled:cursor-not-allowed disabled:border-emerald-300 disabled:bg-emerald-300 disabled:shadow-none">{loading ? <div className='flex justify-center items-center gap-2'>  Cargando <LoaderIcon /></div> : 'Ver Fechas'}</span>
          </Link>





          <div className='pt-2'>



            {eventoFechas && verMas &&
              <>
                {
                  eventoFechas.map((evento, i) => (
                    <div
                      key={i}
                      className="grid grid-cols-4 gap-2 items-center bg-white rounded p-4 mb-2 shadow-sm"
                    >
                      <span className="text-sm font-bebas font-medium text-gray-800 text-center">{convertirFecha(evento.fecha)}</span>
                      <span className="text-sm font-bebas  text-gray-600 text-center">Menor: ${evento.tarifasRackObj.tarifaMenorRack}</span>
                      <span className="text-sm  font-bebas text-gray-600 text-center">Adulto: ${evento.tarifasRackObj.tarifaAdultoRack}</span>
                      <Link
                        onClick={() => setEvento(evento)} role="button" to={`/formulario/${evento.idEvento}`}
                        className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded text-sm text-center font-bebas "
                      >
                        Seleccionar
                      </Link>



                    </div>
                  ))
                }
                <div className=' flex  justify-center'>
                  <button className='bg-zinc-600 hover:bg-zinc-900 text-white px-4 py-2 rounded text-sm text-center font-bebas' onClick={() => setVerMas(false)}> Ver Menos</button>
                </div>
              </>}
          </div>

          {/* <Link onClick={() => onEventoClick(miEvento)}  role="button" to={`/formulario/${miEvento.idEvento}`} >
            <span className="mt-5 inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded bg-emerald-500 px-6 text-md font-medium tracking-wide text-white transition duration-300 hover:bg-emerald-600 focus:bg-emerald-700 focus-visible:outline-none disabled:cursor-not-allowed disabled:border-emerald-300 disabled:bg-emerald-300 disabled:shadow-none">Ver Fechas</span>
          </Link> */}


        </CardReserva>
      </CardBox>
    </div>
  );

}
/*

{miEvento.productoM.id !== 2 && <span className="price trajan-pro">Precio: Antes <strike>{showPrecioForDay(miEvento.fecha)}</strike> promoción descuento <span style={{color:'red'}}>{showDiscountForDay(miEvento.fecha)}</span> ahora queda ARS $ {miEvento.productoM.tarifasM.tarifaAdulto} por persona.</span> } 
{miEvento.productoM.id === 2 && <span className="price trajan-pro">ARS $ {miEvento.productoM.tarifasM.tarifaAdulto} por persona.</span> }
*/
export default EventoFila
